import type { FileStorage } from "../types/FileStorage"
import type { FileStorageBackend } from "../types/FileStorageBackend"
import { Init } from "@pdfking/reactivity/preact"
import { Void } from "@pdfking/tfunc"
import { BaseProviderMixin } from "./base"

export default (store: FileStorage): FileStorageBackend =>
  Init({
    data: { store },
    methods: {
      cleanup: Void,
      open_files: store.open,
      open_folders: store.open,
      refresh() {
        this.populate()
      },
    },
    mixins: [BaseProviderMixin],
  })
